import { Sparkles } from "lucide-react";

export function GoldDivider({ width = 60 }) {
  return (
    <div className="gold-divider" aria-hidden="true">
      <div className="gold-divider__line" style={{ width }} />
      <Sparkles size={14} />
      <div className="gold-divider__line" style={{ width }} />
    </div>
  );
}
